export function reorderPinnedSessionIds(ids: readonly string[], sessionId: string, targetId: string) {
  const from = ids.indexOf(sessionId)
  const to = ids.indexOf(targetId)
  if (from === -1 || to === -1 || from === to) return [...ids]

  const next = [...ids]
  const [moved] = next.splice(from, 1)
  next.splice(to, 0, moved)
  return next
}

export function partitionPinnedItems<T extends { id: string }>(items: readonly T[], pinnedIds: readonly string[]) {
  const itemsById = new Map(items.map((item) => [item.id, item]))
  const pinnedSet = new Set(pinnedIds)
  const pinned = pinnedIds.flatMap((id) => {
    const item = itemsById.get(id)
    return item ? [item] : []
  })
  const unpinned = items.filter((item) => !pinnedSet.has(item.id))
  return [pinned, unpinned] as const
}
